import React, { Component } from 'react';
import '../BirthdayDetails/birthdaydetails.css';
import config from 'config';
import HomeApiCall from 'HomeApiCall';
import { Base64 } from 'js-base64';
import axios from 'axios';
import { faAssistiveListeningSystems } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from 'Home/CommonResources/ButtonLoader/ButtonLoader';
import partyhat from "../../CommonResources/images/partyhat.png"
import Spinner from 'Home/CommonResources/SpinnerLoader/Spinner';
import anniversaryLogo from "../../CommonResources/images/anniversary.png"
import PartyPoper from "../../CommonResources/images/partypopper.png"
class BirthdayDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES TO GET BIRTHDAY DETAILS
            fetchingBirthday: false,
            birthdayDetails: {},
            randomColors: ['#DCEDDD', '#FDDCDA', '#FFE5B3', '#F0E1FF', '#BFF7F3'],
            birthdayData: [],
            birthdayDataModal:[],
            birthdayModalOpen: false,
            selectedType: "all",
            formatedStartDate: "",
            formatedEndDate: "",
            studentBirthday: {},
            facultyBirthday: [],
            fetchingDataOnChange:false
        };
    }

    componentDidMount() {
        // METHOD CALLED TO GET BIRTHDAY DETAILS
        this.apiCallToGetBirthdayDetails();



        const today = new Date();
        const currentDay = today.getDay();
        const startDay = currentDay === 0 ? 6 : currentDay - 1;
        const startDate = new Date(today);
        startDate.setDate(today.getDate() - startDay);

        const year = startDate.getFullYear();
        const month = String(startDate.getMonth() + 1).padStart(2, '0');
        const day = String(startDate.getDate()).padStart(2, '0');

        const formattedStartDate = `${year}-${month}-${day}`;



        const endDay = currentDay === 0 ? 0 : 7 - currentDay;
        const endDate = new Date(today);
        endDate.setDate(today.getDate() + endDay);

        const year_end = endDate.getFullYear();
        const month_end = String(endDate.getMonth() + 1).padStart(2, '0');
        const day_end = String(endDate.getDate()).padStart(2, '0');

        const formattedEndDate = `${year_end}-${month_end}-${day_end}`;

        this.setState({

            formatedStartDate: formattedStartDate,
            formatedEndDate: formattedEndDate,

        }, () => {
            this.apiCallToGetThisWeekBirthday();
            this.apiCallToGetThisWeekAnniversary();
            this.apiCallToGetThisWeekBirthdayOnChange();
            this.apiCallToGetThisWeekAnniversaryOnChange();
        }
        );
    }

    // API CALL METHOD TO GET BIRTHDAY DETAILS
    apiCallToGetBirthdayDetails = async () => {
        this.setState({
            fetchingBirthday: true
        });

        let formData = new FormData();

        formData.append('getTodaysBirthdayInInstitute', true);

        formData.append("iid", config.institute_id);

        let parameterData = JSON.stringify({
            source: 'app',
            uid: config.faculty_id,
            email: config.emailId,
            role: 'instructor'
        });

        formData.append('tokenInputParameter', Base64.encode(parameterData));

        const headers = {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "Authorization": "Basic " + config.user_token
        };

        await axios.post(
            config.RootUrl + '/api/generic_api.php',
            formData,
            {
                headers: headers,
            }
        ).then((response) => {
            let jsonResponse = response.data;



            if (jsonResponse.errorCode == '401') {
                this.apiCallToGetBirthdayDetails();
            } else {
                this.setState({
                    fetchingBirthday: false,
                    birthdayDetails: jsonResponse.data
                });
            }
        }).catch(error => {
            console.log(error);

            this.setState({
                fetchingBirthday: false
            });
        });
    }

    apiCallToGetThisWeekAnniversary = async () => {
        this.setState({
            fetchingBirthday: true
        });


        let requestData = {
            'iid': config.institute_id,
            // 'start_date': "2023-05-04",
            // 'end_date': "2023-05-11"
            'start_date': this.state.formatedStartDate,
            'end_date': this.state.formatedEndDate
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getThisWeekWorkAnniversaryInInstitute',
            requestData,
            '/api/generic_api.php'
        );

        

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetThisWeekAnniversary();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                // let birthdays = [...Object.values(jsonResponse.APIResult.data.faculty), ...Object.values(jsonResponse.APIResult.data.student)]

               

                this.setState({
                    birthdayData: [...Object.values(this.state.birthdayData), ...Object.values(apiResult.faculty)],

                    fetchingBirthday: false
                });
            }
        }
    }

    anniversaryType = (date) => {
        const dateString = date;
        const dateParts = dateString.split("-");

        const year = dateParts[0];
        // const month = new Date(dateString).toLocaleString('en-US', { month: 'long' });
        // const day = parseInt(dateParts[2]);

        let currentYear = new Date().getFullYear();

        let anniversary = currentYear - year;

        if (anniversary <= 0) {
            return ""
        }
        else {
            return `${anniversary}${this.getDaySuffix(anniversary)}`
        }


    }


    apiCallToGetThisWeekBirthday = async () => {
        this.setState({
            fetchingBirthday: true
        });



        let requestData = {
            'iid': config.institute_id,
            'start_date': this.state.formatedStartDate,
            'end_date': this.state.formatedEndDate
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getThisWeekBirthdayInInstitute',
            requestData,
            '/api/generic_api.php'
        );



        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetThisWeekBirthday();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                let birthdays = [...Object.values(jsonResponse.APIResult.data.faculty), ...Object.values(jsonResponse.APIResult.data.student)]

            
                this.setState({
                    birthdayData:birthdays,
                    fetchingBirthday: false
                });
            }
        }
    }


    apiCallToGetThisWeekAnniversaryOnChange = async () => {
        this.setState({
            fetchingDataOnChange: true
        });


        let requestData = {
            'iid': config.institute_id,
            // 'start_date': "2023-05-04",
            // 'end_date': "2023-05-11"
            'start_date': this.state.formatedStartDate,
            'end_date': this.state.formatedEndDate
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getThisWeekWorkAnniversaryInInstitute',
            requestData,
            '/api/generic_api.php'
        );

        

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetThisWeekAnniversary();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                // let birthdays = [...Object.values(jsonResponse.APIResult.data.faculty), ...Object.values(jsonResponse.APIResult.data.student)]

               

                this.setState({
                    birthdayDataModal: [...Object.values(this.state.birthdayDataModal), ...Object.values(apiResult.faculty)],

                    fetchingDataOnChange: false
                });
            }
        }
    }


    apiCallToGetThisWeekBirthdayOnChange = async () => {
        this.setState({
            fetchingDataOnChange: true
        });



        let requestData = {
            'iid': config.institute_id,
            'start_date': this.state.formatedStartDate,
            'end_date': this.state.formatedEndDate
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getThisWeekBirthdayInInstitute',
            requestData,
            '/api/generic_api.php'
        );



        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetThisWeekBirthday();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                let birthdays = [...Object.values(jsonResponse.APIResult.data.faculty), ...Object.values(jsonResponse.APIResult.data.student)]

            
                this.setState({
                    birthdayDataModal:birthdays,
                    fetchingDataOnChange: false
                });
            }
        }
    }


    getDaySuffix = (day) => {
        if (day >= 11 && day <= 13) {
            return "th";
        }
        switch (day % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    }


    dateConversion = (date) => {

        const dateString = date;
        const dateParts = dateString.split("-");

        const year = dateParts[0];
        const month = new Date(dateString).toLocaleString('en-US', { month: 'long' });
        const day = parseInt(dateParts[2]);

        const daySuffix = this.getDaySuffix(day);
        const formattedDate = `${day}${daySuffix} ${month} ${year}`;
        return formattedDate;
    }

    dateConversionWithoutYear = (date) => {

        const dateString = date;
        const dateParts = dateString.split("-");

        const year = dateParts[0];
        const month = new Date(dateString).toLocaleString('en-US', { month: 'long' });
        const day = parseInt(dateParts[2]);

        const daySuffix = this.getDaySuffix(day);
        const formattedDate = `${day}${daySuffix} ${month}`;
        return formattedDate;
    }

    daysToGo = (date) => {

        const dateStr = date;
        const presentDate = new Date();
        const currentYear = presentDate.getFullYear();

        const modifiedDate = dateStr.replace(/^(\d{4})-/, currentYear + "-");


        const specificDate = new Date(modifiedDate);
        const currentDate = new Date();

        const timeDifference = specificDate.getTime() - currentDate.getTime();

        const daysRemaining = Math.ceil(timeDifference / (1000 * 3600 * 24));


        if (daysRemaining == 0) {
            return "Today"
        }
        else if (daysRemaining == 1) {
            return "Tomorrow"
        }
        else if (daysRemaining == -1) {
            return "Yesterday"
        }
        else if (daysRemaining < -1) {
            return `${Math.abs(daysRemaining)} days ago`
        }
        else {
            return `${daysRemaining} days to go`
        }

    }

    closeBirthdayModal = () => {
        const today = new Date();
        const currentDay = today.getDay();
        const startDay = currentDay === 0 ? 6 : currentDay - 1;
        const startDate = new Date(today);
        startDate.setDate(today.getDate() - startDay);

        const year = startDate.getFullYear();
        const month = String(startDate.getMonth() + 1).padStart(2, '0');
        const day = String(startDate.getDate()).padStart(2, '0');

        const formattedStartDate = `${year}-${month}-${day}`;


        const endDay = currentDay === 0 ? 0 : 7 - currentDay;
        const endDate = new Date(today);
        endDate.setDate(today.getDate() + endDay);

        const year_end = endDate.getFullYear();
        const month_end = String(endDate.getMonth() + 1).padStart(2, '0');
        const day_end = String(endDate.getDate()).padStart(2, '0');

        const formattedEndDate = `${year_end}-${month_end}-${day_end}`;


        this.setState({
            birthdayModalOpen: false,
            formatedStartDate: formattedStartDate,
            formatedEndDate: formattedEndDate,
        },
            // () => {
            //     this.apiCallToGetThisWeekBirthday().then(() => this.apiCallToGetThisWeekAnniversary())

            // }
        )
    }

    changeWeek = (val) => {

        let startdate = this.state.formatedStartDate;
        let date = new Date(startdate);

        let enddate = this.state.formatedEndDate;
        let date_end = new Date(enddate);

        date.setDate(date.getDate() + val);
        const start_year_end = date.getFullYear();
        const start_month_end = String(date.getMonth() + 1).padStart(2, '0');
        const start_day_end = String(date.getDate()).padStart(2, '0');
        const newStartingDate = `${start_year_end}-${start_month_end}-${start_day_end}`;

        date_end.setDate(date_end.getDate() + val);
        const end_year_end = date_end.getFullYear();
        const end_month_end = String(date_end.getMonth() + 1).padStart(2, '0');
        const end_day_end = String(date_end.getDate()).padStart(2, '0');
        const newEndingDate = `${end_year_end}-${end_month_end}-${end_day_end}`;

        this.setState({
            formatedStartDate: newStartingDate,
            formatedEndDate: newEndingDate
        }, () => {
            this.apiCallToGetThisWeekBirthdayOnChange().then(() => this.apiCallToGetThisWeekAnniversaryOnChange())
        })
    }

    getDayFromDate(dateString) {
        const options = { weekday: 'short' };
        const date = new Date(dateString);
        const day = date.toLocaleDateString(undefined, options);
        return day;
    }

    birthdayModal = () => {
        return (
            <div className={this.state.birthdayModalOpen ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal-xl" style={{ maxWidth: "90%" }}>
                    <div className="modal-content RecentUpdateModel-content">
                        <div className="modal-header alert-header" style={{ backgroundColor: "#0465ac" }}>
                            <h5 className="text-white">Birthdays & Work Anniversaries of the week!!</h5>
                            <FontAwesomeIcon title='Please press escape to close the recent updates' icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color='white' onClick={() => this.closeBirthdayModal()} />
                        </div>
                        <div className="modal-body" style={{ overflowY: "scroll" }}>

                            <div style={{ display: "flex", justifyContent: "center" }}>
                                {/* <select
                                    className='form-control'
                                    style={{ width: "120px", padding: "5px", borderRadius: "5px" }}
                                    value={this.state.selectedType}
                                    onChange={(e) =>
                                        this.setState({
                                            selectedType: e.target.value,

                                        })
                                    }
                                >
                                    <option value="all">All</option>
                                    <option value="faculty">Faculty</option>
                                    <option value="student">Student</option>

                                </select> */}

                                <div style={{ display: "flex", gap: "2px", }}>
                                    <FontAwesomeIcon
                                        icon={["fas", "arrow-circle-left"]}
                                        size="lg"
                                        color='gray'

                                        onClick={() => this.changeWeek(-7)}
                                        style={{ cursor: "pointer" }}
                                    />
                                    <span
                                        style={{ color: "black", height: "fit-content",backgroundColor:"lightgray", borderRadius: "20px", padding: "0px 5px" }}>
                                        {this.getDayFromDate(this.state.formatedStartDate)}, {this.dateConversion(this.state.formatedStartDate)} - {this.getDayFromDate(this.state.formatedEndDate)}, {this.dateConversion(this.state.formatedEndDate)}
                                    </span>
                                    <FontAwesomeIcon
                                        icon={["fas", "arrow-circle-right"]}
                                        size="lg"
                                        color='gray'

                                        onClick={() => this.changeWeek(7)}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>


                            </div>

                          {/* {
                                this.state.selectedType == "all" &&

                                <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "20px", paddingTop: "10px" }}>
                                    {
                                        this.state.fetchingDataOnChange ?
                                            <Spinner />
                                            :
                                            this.state.birthdayDataModal.length > 0 &&

                                            this.state.birthdayDataModal
                                            .sort((a, b) => {
                                                // Extract month-day (mm-dd) format from dob
                                                const dobA = new Date(a.dob);
                                                const dobB = new Date(b.dob);
                                                const monthDayA = dobA.getMonth() + 1 + '-' + dobA.getDate();
                                                const monthDayB = dobB.getMonth() + 1 + '-' + dobB.getDate();
                        
                                                // Compare the month-day part (ignoring year)
                                                if (monthDayA < monthDayB) return -1;
                                                if (monthDayA > monthDayB) return 1;
                                                return 0;
                                            })
                                            .map((el, i) =>

                                                <div key={i} style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: "8px", display: "flex", borderBottom: "3px solid #2E79CC" }}>

                                                    <div style={{ paddingTop: "2%", width: "85%", display: "flex", gap: "8px", }}>
                                                        <div className='imgdiv' style={{ width: "25%", borderRadius: "5px", }}>
                                                            <img src={el.dp} style={{ width: "100%", borderRadius: "5px", height: "70px" }} />
                                                        </div>

                                                        <div style={{ width: "75%", paddingTop: "2px", textAlign: "center" }}>
                                                            <p style={{ fontSize: "14px", fontWeight: "bold" }}>{el.fname} {el.lname}</p>
                                                            <p style={{ fontSize: "12px", color: "#0C2638" }}>{el.default_branch} | {el.default_group !== "" && el.default_group}</p>
                                                            <p style={{ fontSize: "13px" }}>
                                                                {this.dateConversionWithoutYear(el.dob ? el.dob : el.dateOfJoining)} | {this.daysToGo(el.dob ? el.dob : el.dateOfJoining)}
                                                            </p>
                                                        </div>

                                                    </div>

                                                    <div style={{ width: "15%" }}>

                                                        <div style={{ backgroundColor: el.dob ? "#EBF5FB" : "white", height: "40px", borderRadius: "0% 0% 0% 70%", display: "flex", justifyContent: "center" }}>
                                                            <img src={el.dob ? partyhat : anniversaryLogo}
                                                                alt='hat'
                                                                style={{ width: "90%", marginBottom: "1px" }} />
                                                        </div>
                                                        {el.dateOfJoining &&
                                                            <div style={{ fontSize: "11px", position: "relative", bottom: "40%", left: "20%", color: "white", textAlign: "center", width: "65%" }}>
                                                                <p>{this.anniversaryType(el.dateOfJoining)}</p>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            )

                                    }
                                </div>
                            } */}
                            {/* {this.state.birthdayDataModal.length == 0 &&
                                <div style={{ display: "flex", gap: "5px", color: "#5A5B6A", fontSize: "14px" }}>
                                    <p>Though there are no birthdays & anniversaries this Week! Let's make this week a celebration of life!</p>
                                    <div style={{ width: "20px", position: "relative", bottom: "6px" }}>
                                        <img src={PartyPoper} alt='popper' style={{ width: "100%" }} />
                                    </div>
                                </div>
                                } */}

                            {
                                this.state.selectedType == "all" &&

                                <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "20px", paddingTop: "10px" }}>
                                    {

                                        this.state.fetchingDataOnChange ?
                                            <Spinner />
                                            :
                                            this.state.birthdayDataModal.length > 0 &&

                                            this.state.birthdayDataModal.sort((a, b) => {
                                                // Determine the date field to compare (dob or dateOfJoining)
                                                const dateA = a.dob ? new Date(a.dob) : new Date(a.dateOfJoining);
                                                const dateB = b.dob ? new Date(b.dob) : new Date(b.dateOfJoining);

                                                // Fallback for invalid dates
                                                if (isNaN(dateA) || isNaN(dateB)) {
                                                    return 0; // Keep the original order if any date is invalid
                                                }

                                                // Extract month and day as numbers
                                                const monthDayA = dateA.getMonth() * 100 + dateA.getDate(); // MMDD format
                                                const monthDayB = dateB.getMonth() * 100 + dateB.getDate(); // MMDD format

                                                // if (dateA.getFullYear() !== dateB.getFullYear()) {
                                                //     // We treat December (month 11) as coming before January (month 0) even if the years are different
                                                //     if (dateA.getMonth() === 11 && dateB.getMonth() === 0) {
                                                //         return -1; // December comes before January
                                                //     } else if (dateA.getMonth() === 0 && dateB.getMonth() === 11) {
                                                //         return 1; 
                                                //     }
                                                // }
                                                // Compare numerically
                                                return monthDayA - monthDayB;
                                            })

                                                .map((el, i) =>
                                                    <div key={i} style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: "8px", display: "flex", borderBottom: "3px solid #2E79CC" }}>
                                                        <div style={{ paddingTop: "2%", width: "85%", display: "flex", gap: "8px", }}>
                                                            <div className='imgdiv' style={{ width: "25%", borderRadius: "5px", }}>
                                                                <img src={el.dp} style={{ width: "100%", borderRadius: "5px", height: "70px" }} />
                                                            </div>

                                                            <div style={{ width: "75%", paddingTop: "2px", textAlign: "center" }}>
                                                                <p style={{ fontSize: "14px", fontWeight: "bold" }}>{el.fname} {el.lname}</p>
                                                                <p style={{ fontSize: "12px", color: "#0C2638" }}>{el.default_branch} | {el.default_group !== "" && el.default_group}</p>
                                                                <p style={{ fontSize: "13px" }}>
                                                                    {this.dateConversionWithoutYear(el.dob ? el.dob : el.dateOfJoining)} | {this.daysToGo(el.dob ? el.dob : el.dateOfJoining)}
                                                                </p>
                                                            </div>

                                                        </div>

                                                        <div style={{ width: "15%" }}>
                                                            <div style={{ backgroundColor: el.dob ? "#EBF5FB" : "white", height: "40px", borderRadius: "0% 0% 0% 70%", display: "flex", justifyContent: "center" }}>
                                                                <img src={el.dob ? partyhat : anniversaryLogo}
                                                                    alt='hat'
                                                                    style={{ width: "90%", marginBottom: "1px" }} />
                                                            </div>
                                                            {el.dateOfJoining &&
                                                                <div style={{ fontSize: "11px", position: "relative", bottom: "40%", left: "20%", color: "white", textAlign: "center", width: "65%" }}>
                                                                    <p>{this.anniversaryType(el.dateOfJoining)}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                )

                                    }
                                </div>
                            }



                            {/* {
                                this.state.selectedType == "faculty" &&
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "20px", paddingTop: "10px" }}>
                                    {
                                        this.state.fetchingBirthday ?
                                            <Spinner />
                                            :
                                            Object.values(this.state.facultyBirthday).length > 0 ?

                                                Object.values(this.state.facultyBirthday).map((el, i) =>

                                                    <div key={i} style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: "8px", display: "flex", borderBottom:"3px solid #2E79CC"}}>

                                                        <div style={{ paddingTop: "2%", width: "85%", display: "flex", gap: "8px", }}>
                                                            <div className='imgdiv' style={{ width: "25%", borderRadius: "5px", }}>
                                                                <img src={el.dp} style={{ width: "100%", borderRadius: "5px", height: "70px" }} />
                                                            </div>

                                                            <div style={{ width: "75%", paddingTop: "2px", textAlign: "center" }}>
                                                                <p style={{ fontSize: "14px", fontWeight: "bold" }}>{el.fname} {el.lname}</p>
                                                                <p style={{ fontSize: "12px", color: "#0C2638" }}>{el.default_branch}</p>
                                                                <p style={{ fontSize: "13px" }}>{this.dateConversionWithoutYear(el.dob)} | {this.daysToGo(el.dob)}</p>
                                                            </div>

                                                        </div>

                                                        <div style={{ width: "15%" }}>

                                                            <div style={{ backgroundColor: "#EBF5FB ", height: "40px", borderRadius: "0% 0% 0% 70%", display: "flex", justifyContent: "center" }}>
                                                                <img src={partyhat} alt='hat' style={{ width: "90%", marginBottom: "1px" }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                                :
                                                <p>No birthdays for selected week and selected category</p>

                                    }
                                </div>
                            } */}
                            {/* 
                            {
                                this.state.selectedType == "student" &&
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "20px", paddingTop: "10px" }}>
                                    {
                                        this.state.fetchingBirthday ?
                                            <Spinner />
                                            :
                                            Object.values(this.state.studentBirthday).length > 0 ?

                                                Object.values(this.state.studentBirthday).map((el, i) =>

                                                    <div key={i} style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: "8px", display: "flex", borderBottom:"3px solid #2E79CC"}}>

                                                        <div style={{ paddingTop: "2%", width: "85%", display: "flex", gap: "8px", }}>
                                                            <div className='imgdiv' style={{ width: "25%", borderRadius: "5px", }}>
                                                                <img src={el.dp} style={{ width: "100%", borderRadius: "5px", height: "70px" }} />
                                                            </div>

                                                            <div style={{ width: "75%", paddingTop: "2px", textAlign: "center" }}>
                                                                <p style={{ fontSize: "14px", fontWeight: "bold" }}>{el.fname} {el.lname}</p>
                                                                <p style={{ fontSize: "12px", color: "#0C2638" }}>{el.default_branch}</p>
                                                                <p style={{ fontSize: "13px" }}>{this.dateConversionWithoutYear(el.dob)} | {this.daysToGo(el.dob)}</p>
                                                            </div>

                                                        </div>

                                                        <div style={{ width: "15%" }}>

                                                            <div style={{ backgroundColor: "#EBF5FB ", height: "40px", borderRadius: "0% 0% 0% 70%", display: "flex", justifyContent: "center" }}>
                                                                <img src={partyhat} alt='hat' style={{ width: "90%", marginBottom: "1px" }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                                :
                                                <p>No birthdays for selected week and selected category</p>
                                    }
                                </div>
                            } */}

                        </div>
                    </div>
                </div>
            </div >
        );
    }




    render() {
        return (
            <>
                <div>
                    <div className='birthdayHeading'>
                        <h6 style={{ color: "black", fontWeight: "bold",fontSize:"15px"}}>Birthdays & Work Anniversaries of the week!</h6>

                        <p style={{cursor:"pointer",textDecoration: "underline", fontSize: "14px",color:"rgb(41, 121, 255)" }} onClick={() => this.setState({ birthdayModalOpen: true })}>View more</p>
                    </div>

                    {
                        this.state.fetchingBirthday ?
                            <div style={{ width: "20px" }}><Spinner /></div>
                            :
                            this.state.birthdayData.length > 0 ?
                                <div style={{ display: "flex", gap: "30px", }}>
                                    {
                                        this.state.birthdayData
                                        // .sort((a, b) => {
                                        //     // Determine the date field to compare (dob or dateOfJoining)
                                        //     const dateA = a.dob ? new Date(a.dob) : new Date(a.dateOfJoining);
                                        //     const dateB = b.dob ? new Date(b.dob) : new Date(b.dateOfJoining);
                        
                                        //     // Extract month-day (mm-dd) format from date
                                        //     const monthDayA = dateA.getMonth() + 1 + '-' + dateA.getDate();
                                        //     const monthDayB = dateB.getMonth() + 1 + '-' + dateB.getDate();
                                        //     if (dateA.getFullYear() !== dateB.getFullYear()) {
                                        //         // We treat December (month 11) as coming before January (month 0) even if the years are different
                                        //         if (dateA.getMonth() === 11 && dateB.getMonth() === 0) {
                                        //             return -1; // December comes before January
                                        //         } else if (dateA.getMonth() === 0 && dateB.getMonth() === 11) {
                                        //             return 1; // January comes after December
                                        //         }
                                        //     }
                                        //     // Compare the month-day part (ignoring year)
                                        //     if (monthDayA < monthDayB) return -1;
                                        //     if (monthDayA > monthDayB) return 1;
                                        //     return 0;
                                        // })
                                        
                                        .sort((a, b) => {
                                            // Determine the date field to compare (dob or dateOfJoining)
                                            const dateA = a.dob ? new Date(a.dob) : new Date(a.dateOfJoining);
                                            const dateB = b.dob ? new Date(b.dob) : new Date(b.dateOfJoining);
                                            const monthDayA = dateA.getMonth() * 100 + dateA.getDate(); // MMDD format
                                            const monthDayB = dateB.getMonth() * 100 + dateB.getDate(); // MMDD format
                                            return monthDayA - monthDayB;
                                        })
                                        .map((el, i) =>

                                            i <= 3 &&
                                            <div key={i} style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: "8px", display: "flex", width: "300px", borderBottom: "3px solid #2E79CC" }}>

                                                <div style={{ paddingTop: "2%", width: "85%", display: "flex", gap: "8px" }}>
                                                    <div className='imgdiv' style={{ width: "25%", borderRadius: "5px" }}>
                                                        <img src={el.dp} style={{ width: "100%", borderRadius: "5px", height: "70px" }} />
                                                    </div>

                                                    <div style={{ width: "75%", paddingTop: "2px", textAlign: "center" }}>
                                                        <p style={{ fontSize: "14px", fontWeight: "bold" }}>{el.fname} {el.lname}</p>
                                                        <p style={{ color: "#0C2638", fontSize: "12px" }}>{el.default_branch} | {el.default_group !== "" && el.default_group}</p>
                                                        <p style={{ fontSize: "13px" }}>
                                                            {this.dateConversionWithoutYear(el.dob ? el.dob : el.dateOfJoining)} | {this.daysToGo(el.dob ? el.dob : el.dateOfJoining)}
                                                        </p>
                                                    </div>

                                                </div>

                                                <div style={{ width: "15%" }}>

                                                    <div style={{ backgroundColor: el.dob ? "#EBF5FB" : "white", height: "40px", borderRadius: "100%", display: "flex", justifyContent: "center" }}>
                                                        <img src={el.dob ? partyhat : anniversaryLogo}
                                                            alt='hat'
                                                            style={{ width: el.dob ? "90%" : "80%", marginBottom: "1px" }} />
                                                    </div>
                                                    {el.dateOfJoining &&
                                                        <div style={{ fontSize: "11px", position: "relative", bottom: "40%", left: "20%", color: "white", textAlign: "center", width: "65%" }}>
                                                            <p>{this.anniversaryType(el.dateOfJoining)}</p>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }

                                </div>
                                :
                                <div style={{ display: "flex", gap: "5px", fontSize: "12.5px" }}>
                                    <p style={{color: "#5A5B6A",fontWeight:"bold"}}>Though there are no birthdays & anniversaries this Week! Let's make this week a celebration of life!</p>
                                    <div style={{ width: "20px", position: "relative", bottom: "6px" }}>
                                        <img src={PartyPoper} alt='popper' style={{ width: "100%" }} />
                                    </div>
                                </div>
                    }


                </div>
                {this.birthdayModal()}
            </>
        );
    }
}

export default BirthdayDetails;